module.exports = __webpack_public_path__ + "img/zan_icon.29b1e21f.png";